const realPath = window.location.href.toString().split('/')

export default {
  prepareLinkedin (link) {
    const myLinkedin = JSON.parse(link)
    return myLinkedin.linkedin
  },
  prepareLattes (link) {
    const myLattes = JSON.parse(link)
    return myLattes.lattes
  },
  openProfileProfessional: function (crm, uf) {
    window.open('http://' + realPath[2] + '/' + crm + '/' + uf, '_blank')
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/components/links-profile/resources/methods.js